import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';

const LANGUAGES: { code: string; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'ar', label: 'AR' },
  { code: 'ur', label: 'UR' },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const cycle = () => {
    const idx = LANGUAGES.findIndex((l) => l.code === i18n.language);
    const next = LANGUAGES[(idx + 1) % LANGUAGES.length];
    i18n.changeLanguage(next.code);
  };

  const current = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

  return (
    <Button variant="ghost" size="sm" onClick={cycle} className="gap-2">
      <Globe className="h-4 w-4" />
      <span className="font-mono text-xs">{current.label}</span>
    </Button>
  );
}
